"use client";

import { PublicUser } from "@/types";
import { useTranslations } from "next-intl";

interface TeamCardPlayersProps {
  players: PublicUser[];
  captainId: string;
  /** When true, player names are hidden (e.g. a forfeited team). */
  hideNames?: boolean;
}

export function TeamCardPlayers({
  players,
  captainId,
  hideNames = false,
}: TeamCardPlayersProps) {
  const t = useTranslations();
  return (
    <div className="min-h-[32px] sm:min-h-[44px] md:min-h-[48px] flex flex-col justify-center">
      {players.map((player) => {
        const isCaptain = player.id === captainId;
        return (
          <div
            key={player.id}
            className="flex items-center justify-center gap-0.5 sm:gap-1 md:gap-1.5 py-0.5 sm:py-1 md:py-1 text-[0.7rem] sm:text-[0.75rem] md:text-[0.85rem] leading-tight text-white"
          >
            {isCaptain && (
              <span
                className="text-[0.5rem] sm:text-[0.65rem] text-gold flex-shrink-0"
                aria-label={t("common.captain")}
              >
                ⭐
              </span>
            )}
            <span className="truncate min-w-0 max-w-full">
              {hideNames ? t("teams.forfeit.hiddenPlayer") : player.name}
            </span>
          </div>
        );
      })}
    </div>
  );
}
